export default {
  type: 'layoutRows',
  shadow: '@theme:card.shadow',
  fontName: '@theme:card.fontName',
  rounded: '@theme:card.rounded',
  hover: 'light-7',
  bgColor: 'white',
  border: true,
  padding: '0',
  fontSize: '3',
  separatorJourneyTypeProps: {
    content: '|',
  },
  showJourneyType: true,
  showTravelClass: true,
  fareItemOriginDestination: {
    showOriginAirportCode: true,
    showDestinationAirportCode: true,
    showOriginLabel: true,
    showDestinationLabel: true,
    showSeparator: false,
    showLineSeparator: true,
    fontSize: '3',
    textTransform: 'capitalize',
    marginBottom: '2',
    style: {
      lineHeight: '1',
    },
    originLabelStyles: {
      paddingRight: '1',
      fontWeight: 'bold',
    },
    destinationLabelStyles: {
      paddingRight: '1',
      fontWeight: 'bold',
    },
    originAirportCodeStyles: {
      paddingRight: '1',
      fontWeight: 'bold',
    },
    destinationAirportCodeStyles: {
      paddingRight: '1',
      fontWeight: 'bold',
    },
    lineSeparatorStyles: {
      marginBottom: '1',
    },
  },
  showRoute: false,
  fareItemRoute: {
    fontWeight: 'bold',
    fontSize: '4',
    paddingBottom: '1',
    separatorLabel: {
      content: 'minus',
    },
  },
  showDepartureInfo: false,
  fareItemDepartureInfo: {
    showDepartureText: false,
    showDepartureDate: true,
    departureTextLabelStyle: {
      fontWeight: 'bold',
    },
  },
  separatorDatesProps: {
    content: 'minus',
  },
  showReturnInfo: false,
  fareItemReturnInfo: {
    showReturnText: false,
    showReturnDate: true,
    returnTextLabelStyles: {
      fontWeight: 'bold',
    },
  },
  showOriginDestinationImage: true,
  fareItemOriginDestinationImage: {
    heightDestinationImage: 100,
    widthDestinationImage: 100,
    roundedLeft: '@theme:card.rounded',
  },
  showPrice: true,
  fareItemDepartureReturn: {
    marginBottom: '1',
  },
  fareItemPrice: {
    pricePromoLabelKey: 'cmp-fare-price-promo-short',
    fontSize: '4',
    textAlign: 'right',
    fontWeight: 'bold',
    marginLeft: 'auto',
    showCurrencyCode: true,
    showCurrencySymbol: false,
    showPricePromo: true,
    pricePromoStyles: {
      fontWeight: 'normal',
      fontSize: '3',
      textTransform: 'lowercase',
      marginRight: '2',
      textColor: 'dark',
    },
    currencyStyles: {
      marginHeight: '1',
    },
  },
  fareImageItem: {
    grow: '2',
  },
  fareContentItem: {
    grow: '5',
    padding: '2',
    justifyContent: 'between',
  },
  fareFooterItem: {
    alignItems: 'end',
  },
  showDurationTrip: false,
  showLastSeen: false,
  fareItemLastSeen: {
    shadow: '@theme:card.shadow',
    rounded: '@theme:badge.rounded',
    fontName: '@theme:card.fontName',
    bgColor: 'light',
    padding: '6px',
    marginLeft: 'auto',
    labelStyles: {
      fontWeight: 'bold',
    },
  },
  showAirline: false,
  fareItemAirline: {
    showAirlineLogo: true,
    showAirlineName: true,
    borderTop: true,
    airlineNameStyles: {
      fontSize: '3',
    },
  },
  showFareDisclaimer: false,
  fareItemDisclaimer: {
    borderTop: true,
    fontSize: '3',
    paddingWidth: '2',
  },
  showCallToAction: false,
  fareItemCallToAction: {
    showCallToActionTextMin: true,
    shadow: '@theme:button.shadow',
    rounded: '@theme:button.rounded',
    width: '100',
    paddingHeight: '2',
    textTransform: 'uppercase',
    fontSize: '4',
    fontWeight: 'bold',
  },
};
